import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Optional,
  ViewChild,
} from "@angular/core";
import { UntypedFormGroup, Validators } from "@angular/forms";
import {
  RxFormBuilder,
  RxwebValidators,
} from "@rxweb/reactive-form-validators";
import {
  ValidInput,
  noWhitespaceValidator,
} from "../../../../../@core/utils/helpers";
import Uppy from "@uppy/core";
import {
  ChatGPTClient,
  ExtractURLCommand,
  GetDocumentDataQuery,
  RetrieveURLCommand,
} from "../../../../../System-api";
import {
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmDialogComponent } from "../../../../../shared/confirm-dialog/confirm-dialog.component";
import Dashboard from "@uppy/dashboard";

@Component({
  selector: "update-dataset",
  templateUrl: "./update-dataset.component.html",
  styleUrls: ["./update-dataset.component.scss"],
})
export class UpdateDatasetComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild("urlBox") urlBox: ElementRef<HTMLDivElement>;

  datasetForm: UntypedFormGroup;
  isLoading: boolean = false;
  isSaveLoading: boolean = false;
  isLoadingExtract: boolean = false;
  isAction: boolean = false;
  isUpdate: boolean = false;
  crawlDepth: number;
  title: string = "";
  data: any = {
    name: "",
    model: "text-embedding-ada-002",
    description: "",
    type: "TEXT",
    sourceType: "",
    dataTrain: "",
    content: "",
    chunkType: "auto",
    chunkSetting: "",
    documentName: "",
    paragraph_separator: "\\n\\n\\n",
    chunk_size: 200,
    chunk_overlap: 0,
    remove_extra_spaces: false,
    retrainTime: "",
    files: null,
  };
  updateType = "";
  idGPT = 0;
  uppy: Uppy = new Uppy({
    autoProceed: true,
    restrictions: {
      minNumberOfFiles: 1,
      allowedFileTypes: [".txt", ".pdf", ".doc", ".docx", ".md"],
    },
  });

  totalFile = 0;
  fileUpload: any;
  listUrl = [];
  mainURL: string = null;
  newURL: string = null;
  checkAll = true;
  isRetrieve: boolean = false;
  listFileUpload: any = [];
  errorMessage: string = "Somethings went wrong, try again";
  eventListener: any;
  searchLogo = "../../../../../../assets/images/searching.gif";
  constructor(
    private formBuilder: RxFormBuilder,
    private chatGPTClient: ChatGPTClient,
    private toastrService: NbToastrService,
    private router: Router,
    private dialogService: NbDialogService,
    private activatedRoute: ActivatedRoute,
    @Optional() private ref: NbDialogRef<UpdateDatasetComponent>
  ) {}
  onChangeContentText(event) {
    const textArea = document.getElementById("content-training-knowledge");
    if (textArea) {
      if (event?.trim()) {
        textArea.style.height = `${textArea.scrollHeight + 2}px`;
      } else {
        textArea.style.height = "200px";
      }
    }
  }
  onkeypress($event) {
    return $event.charCode >= 48 && $event.charCode <= 57;
  }
  ngOnDestroy() {
    if (this.eventListener) {
      document.removeEventListener("click", this.eventListener);
      this.eventListener = null;
    }
  }
  ngAfterViewInit() {}
  changeType(type) {
    this.data.type = type;
  }
  changeSourceType(type) {
    this.data.sourceType = type;
    if (type == "CUSTOM") {
      this.datasetForm.get("documentName")?.setValidators([
        RxwebValidators.required(),
        noWhitespaceValidator,
        Validators.maxLength(50),
        RxwebValidators.pattern({
          expression: {
            regex: /^[^\\\/:*?"<>|]+$/,
          },
        }),
      ]);
      this.datasetForm.get("documentName")?.updateValueAndValidity();
    } else {
      this.datasetForm.get("documentName")?.setValidators([]);
      this.datasetForm.get("documentName")?.updateValueAndValidity();
    }
  }
  changeTrunk(type) {
    this.data.chunkType = type;
  }
  ngOnInit(): void {
    if (this.isUpdate) {
      this.data.sourceType = this.updateType;
    }
    this.createForm();
    this.uppy.on("file-added", (file) => {
      if (file.data instanceof Blob) {
        if (file.data instanceof File) {
          const existFile = this.listFileUpload.some(
            (element) => element.name === file.name
          );
          if (existFile) {
            this.uppy.info(
              `Cannot add the duplicate file '${file.name}', it already exists.`,
              "error"
            );
            this.uppy.removeFile(file.id);
          } else {
            this.listFileUpload.push(file);
          }
        }
      }
      var files = this.uppy.getFiles();
      this.totalFile = files.length;
    });
    this.uppy.on("file-removed", (file, reason) => {
      var files = this.uppy.getFiles();
      if (files.length < this.listFileUpload.length) {
        this.listFileUpload = this.listFileUpload.filter(
          (e) => e.name != file.name
        );
      }
      this.totalFile = files.length;
    });
    this.eventListener = (e: any) => {
      document.querySelectorAll(".uppy-Dashboard-Item")?.forEach((item) => {
        if (item.contains(e?.target)) {
          this.download(item.id);
        }
      });
    };
    document.addEventListener("click", this.eventListener);
    if (this.data.sourceType === "CUSTOM") {
      this.datasetForm.get("documentName")?.setValidators([
        RxwebValidators.required(),
        noWhitespaceValidator,
        Validators.maxLength(50),
        RxwebValidators.pattern({
          expression: {
            regex: /^[^\\\/:*?"<>|]+$/,
          },
        }),
      ]);
      this.datasetForm.get("documentName")?.updateValueAndValidity();
    }
  }

  createForm() {
    if (this.isUpdate) {
      this.datasetForm = this.formBuilder.group({
        name: [""],
        model: [""],
        description: [""],
        mainURL: [""],
        newURL: [""],
        crawlDepth: [""],
        content: [""],
        documentName: [""],
        paragraph_separator: [""],
        chunk_size: [""],
        chunk_overlap: [""],
        remove_extra_spaces: [""],
        retrainTime: ["", ValidInput.retrainTime],
      });
    } else {
      this.datasetForm = this.formBuilder.group({
        name: [
          "",
          [
            RxwebValidators.required(),
            noWhitespaceValidator,
            Validators.maxLength(50),
            RxwebValidators.pattern({
              expression: {
                regex: /^[^\\\/:*?"<>|]+$/,
              },
            }),
          ],
        ],
        model: [""],
        description: [""],
        mainURL: [""],
        newURL: [""],
        crawlDepth: [""],
        content: [""],
        documentName: [""],
        paragraph_separator: [""],
        chunk_size: [""],
        chunk_overlap: [""],
        remove_extra_spaces: [""],
        retrainTime: ["", ValidInput.retrainTime],
      });
    }
  }

  handleAddFile(document) {
    this.listFileUpload.push(document);
    const byteCharacters = atob(document.data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: "application/octet-stream" });

    // Set the file in Uppy
    this.uppy.addFile({
      source: document.source,
      data: blob,
      name: document.name,
    });
  }

  getAllFiles() {
    var files = this.uppy.getFiles();
    files.forEach((element) => {
      (element as any).fileName = element.name;
    });
    return files;
  }

  back() {
    this.router.navigate(["/portal/studio/knowledge-base"]);
  }

  dismiss() {
    this.ref.close();
  }

  onChangeText(event) {
    const text = event.target.value;

    // Save the selection range
    const selectionStart = event.srcElement.selectionStart;
    const selectionEnd = event.srcElement.selectionEnd;

    // Replace the text
    let newText = text.replace(/(^|\n)([^\u2022])/g, "$1\u2022 $2");
    newText = newText.replace(/\u2022\s*\u2022/g, "\u2022");
    event.srcElement.value = newText;

    // Restore the selection range
    const newSelectionStart = selectionStart + (newText.length - text.length);
    const newSelectionEnd = selectionEnd + (newText.length - text.length);
    event.srcElement.setSelectionRange(newSelectionStart, newSelectionEnd);
    this.mainURL = newText;
    return newText;
  }

  toggleAll(event) {
    this.listUrl.forEach((item, index) => {
      this.listUrl[index].enable = event;
    });
    this.checkAll = event;
  }

  removeAll() {
    this.dialogService
      .open(ConfirmDialogComponent, {
        autoFocus: true,
        context: {
          question: "All unchecked URLs will go to the trash list. Sure?",
          textYes: "Delete",
          textNo: "Cancel",
          statusYes: "danger",
          statusNo: "basic",
        },
      })
      .onClose.subscribe((isConfirm) => {
        if (isConfirm) {
          this.listUrl = this.listUrl.filter((item) => {
            return item.enable == true;
          });
          this.resetToggle();
        }
      });
  }

  resetToggle() {
    const data = this.listUrl?.filter((element) => {
      return element.enable == true;
    });
    if (data.length == this.listUrl.length) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }

  toggle(event, index) {
    this.listUrl[index].enable = event;
    this.resetToggle();
  }

  removeUrl(index) {
    if (index != 0) {
      this.listUrl.splice(index, 1);
    } else {
      this.listUrl.shift();
    }
    this.resetToggle();
  }

  handleGetURL() {
    return [this.mainURL];
  }

  extractURL() {
    if (this.mainURL) {
      const urls = this.handleGetURL();
      this.isLoadingExtract = true;
      let data = new ExtractURLCommand();
      data.urls = urls;
      data.maxDepth = this.crawlDepth || 1;
      this.isRetrieve = true;
      this.chatGPTClient.extractURL(data).subscribe({
        next: (rs) => {
          if (rs) {
            let count = 0;
            rs.forEach((item) => {
              const data = this.listUrl?.filter((element) => {
                return element.url == item;
              });
              if (data.length <= 0) {
                this.listUrl.push({
                  url: item,
                  enable: true,
                });
                count++;
              }
            });
            this.toastrService.show(
              `Result: ${count} new ${
                count > 1 ? "URLs" : "URL"
              } added to the list`,
              `Notification`,
              {
                position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
                status: "success",
              }
            );
          } else {
            this.toastrService.show(this.errorMessage, `Notification`, {
              position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
              status: "danger",
            });
          }
          this.isRetrieve = false;
          this.isLoadingExtract = false;
        },
        error: (error) => {
          this.isLoadingExtract = false;
          this.isRetrieve = false;
          this.toastrService.show(this.errorMessage, `Notification`, {
            position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
            status: "danger",
          });
        },
      });
    }
  }
  handleAddNewURL() {
    if (this.newURL) {
      const urls = [this.newURL];
      urls.forEach((url) => {
        this.addNewURL(url.trim());
      });
    }
  }

  download(id: string) {
    if (id) {
      id = id.substring("uppy_".length);
      var file = this.uppy.getFile(id);
      if (file) {
        this.dialogService
          .open(ConfirmDialogComponent, {
            autoFocus: false,
            context: {
              question: "Do you want to download file " + file.name + " ?",
              textYes: "Download",
              textNo: "Cancel",
              statusYes: "primary",
              statusNo: "basic",
            },
          })
          .onClose.subscribe((isConfirm) => {
            if (isConfirm) {
              const reader = new FileReader();
              reader.onloadend = () => {
                const base64String: string = reader.result as string;
                let temp = this.dataURLtoFile(base64String);
                this.downloadData(file.name, temp);
              };
              reader.readAsDataURL(file.data);
            }
          });
      }
    }
  }
  dataURLtoFile(dataurl) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], "", { type: mime });
  }

  downloadData(filenameForDownload: string, data: any) {
    var textUrl = URL.createObjectURL(data);
    var element = document.createElement("a");
    element.setAttribute("href", textUrl);
    element.setAttribute("download", filenameForDownload);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  addNewURL(url) {
    if (url && this.isURL(url)) {
      const data = this.listUrl.filter((item) => {
        const trimmedUrl = url.endsWith("/") ? url.slice(0, -1) : url;
        return item.url == trimmedUrl || item.url == trimmedUrl + "/";
      });
      if (data.length <= 0) {
        var obj = { url: url, enable: true };
        this.listUrl = [obj, ...this.listUrl];
        this.toastrService.show(`Add URL successfully`, `Notification`, {
          position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
          status: "success",
        });
        setTimeout(() => {
          this.urlBox.nativeElement.scrollTop =
            this.urlBox.nativeElement.scrollHeight;
        }, 50);
      } else {
        this.toastrService.show(`${url} already exists`, `Notification`, {
          position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
          status: "danger",
        });
      }
    } else {
      this.toastrService.show(`${url} not valid`, `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "danger",
      });
    }
  }

  isURL(value: string): boolean {
    const urlPattern =
      /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    return urlPattern.test(value);
  }

  setValidationErrors(errorData) {
    var errorData = JSON.parse(errorData);
    if (errorData) {
      for (const [key, value] of Object.entries(errorData)) {
        const fieldName = key.toLowerCase(); // Ensure case matches form control names
        const errorMessage = value[0];
        if (this.datasetForm.get(fieldName)) {
          const control = this.datasetForm.get(fieldName);
          control.setErrors({ serverError: errorMessage });
          control.markAsDirty();
        }
      }
    }
  }

  onSubmit() {
    if (this.datasetForm.valid) {
      if (this.data.sourceType == "WEB_CRAWL")
        this.data.dataTrain = JSON.stringify(this.listUrl);
      if (this.data.sourceType == "LOCAL_DOCUMENT") {
        this.data.retrainData = "";
        this.fileUpload = this.getAllFiles();
      }
      this.data.name = this.data.name?.trim();
      this.isLoading = true;
      let chunk = "";
      if (this.data.chunkType == "custom") {
        chunk = JSON.stringify({
          chunk_size: this.data.chunk_size,
          chunk_overlap: this.data.chunk_overlap,
          paragraph_separator: this.data.paragraph_separator,
          remove_extra_spaces: this.data.remove_extra_spaces,
        });
      }
      this.chatGPTClient
        .create(
          this.idGPT,
          this.data.name,
          this.data.description,
          this.data.model,
          this.data.type,
          this.data.sourceType,
          this.data.dataTrain,
          this.data.content,
          chunk,
          this.data.retrainTime,
          this.data.documentName,
          this.fileUpload as any
        )
        .subscribe({
          next: (rs) => {
            this.isLoading = false;
            if (rs) {
              this.showToast(true);
              this.ref.close({ rs: rs, name: this.data.name });
            } else {
              this.data.status = "FAILED";
              this.showToast(false);
            }
          },
          error: (error) => {
            this.isLoading = false;
            this.showToast(false);
            if (error.status == 422) {
              this.setValidationErrors(error.response);
            }
          },
        });
    }
  }

  trainingDataset() {
    if (this.datasetForm.valid) {
      if (this.data.type == "URL")
        this.data.dataTrain = JSON.stringify(this.listUrl);
      if (this.data.type == "DOCUMENT") {
        this.data.retrainData = "";
        this.fileUpload = this.getAllFiles();
      }
      this.isLoading = true;
      this.chatGPTClient
        .train(
          this.data.id,
          this.data.name,
          this.data.description,
          this.data.type,
          this.data.dataTrain,
          this.data.retrainTime,
          this.fileUpload as any
        )
        .subscribe({
          next: (rs) => {
            this.isLoading = false;
            if (rs && rs > 0) {
              this.showToast(true);
            } else {
              this.showToast(false);
            }
          },
          error: (error) => {
            this.isLoading = false;
            this.showToast(false);
            if (error.status == 422) {
              this.setValidationErrors(error.response);
            }
          },
        });
    }
  }

  showToast(result) {
    if (result == "required") {
      this.toastrService.show("Data is required", `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "danger",
      });
    } else if (result == true) {
      this.toastrService.show("Save knowledge successfully", `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "success",
      });
    } else {
      this.toastrService.show("Save knowledge unsuccessfully", `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "danger",
      });
    }
  }
}
